import RecommendedAudiences from "./RecommendedAudiences";

import "./RecommendedAudiences.scss";

export * from "./RecommendedAudiences.types";

export { RecommendedAudiences };
